//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 03.03.2016.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .directive('srsngExtensionMenu', srsngExtensionMenu);

    function srsngExtensionMenu() {

        return {
            restrict: 'E',
            scope: {
                visible: '='
            },
            templateUrl: 'container/ui/app/layout/navigation/extension-menu/extension-menu.html',
            controller: controller
        };

        function controller($rootScope, $scope, extensionService) {

            $rootScope.$on('extensionService:activeExtensionChanged', getExtensions);

            $scope.extensionMenu = {
                visible: false
            };

            $scope.closeMenu = function () {
                $scope.extensionMenu.visible = false;
            };

            $scope.toggleExtensionMenu = function ($event) {
                $scope.extensionMenu.visible = !$scope.extensionMenu.visible;
                $event.stopPropagation();
            };

            function getExtensions() {
                $scope.activeExtension = extensionService.getActiveExtension();
                $scope.extensions = extensionService.getExtensions();
            }

            getExtensions();
        }
    }
}());